import {PaymentMassStatusChangeList} from "./payment-mass-status-change-list";

export class PaymentMassStatusChange {
  statusCode: string;
  changeList: PaymentMassStatusChangeList[] = [];
}
